import React, { useCallback, useEffect, useRef } from 'react';
import { getAccessToken } from '../../../auth';
import { useParams } from 'react-router-dom';
import { Logger } from '@elyx-code/common-ts-utils';
import { envConfig } from '../../../config';

interface IHTTPAPIClientModuleProps {
	envIdentifiers: string[];
}

const HTTPAPIClientModule: React.FC<IHTTPAPIClientModuleProps> = ({
	envIdentifiers,
}) => {
	const { id: projectId } = useParams<{ id: string }>();
	const iframeRef = useRef(null);

	const init = useCallback(async () => {
		const accessToken = await getAccessToken();

		const url = `${envConfig.HTTP_CLIENT_URL}/?projectId=${projectId}&envIdentifiers=${envIdentifiers.join(',')}&accessToken=${accessToken}`;
		Logger.log('HTTPAPIClientModule module URL', url);

		iframeRef.current.src = url;
	}, [projectId, envIdentifiers]);

	useEffect(() => {
		init();
	}, [projectId]);

	return (
		<div style={{ display: 'flex', flexDirection: 'column' }}>
			<iframe style={{ height: '670px', border: 'none' }} ref={iframeRef} />
		</div>
	);
};

export default HTTPAPIClientModule;
